import { Flex, Box, Avatar, HStack, Text, Img, Link, IconButton} from '@chakra-ui/react';

import blackThalamusLogo from './1st.svg';
import DOMPurify from 'dompurify';
import FileIcon from '../../components/FileIcon';
import { DownloadFile2 } from '../../components/DownloadFile';
import { InfoOutlined } from '@mui/icons-material';

const MessageTile = ({ workspaceOpened, message, prevMsg }) => {
  if (
    message.type === 'planner_message' ||
    message.type === 'action_message'
  )
    return null;
  if (message.sender === 'ai')
    return (
      <HStack
      gap={2} wordBreak={'break-word'} p={"8px"} pt = { prevMsg?.sender === "human" ? "40px" : "8px" } 
      marginRight={"25%"} 
      >
        {
          // prevMsg?.sender === "ai" ? <Box minWidth="36px"></Box> : (
            <Box style={{ minWidth: '36px' }} pY={0} alignSelf={"flex-start"}>
              <Img src={blackThalamusLogo} alt="Thalamus logo" boxSize="36px" />
            </Box>
          // )
        }
        <Box flexDir={'column'} gap={2} paddingTop="0px" alignSelf={"center"}>
          {/* <Box fontSize={18} fontWeight={600}>
            Thalamus
          </Box> */}
          <MessageText message={message} />
        </Box>
      </HStack>
    );
  if (message.sender === 'human')
    return (
      <Flex
        gap={0}
        // backgroundColor={'#E4F0FF'}
        // padding={"12px"}
        // paddingTop={3}
        // paddingBottom={0}
        borderRadius={'16px'}
        // paddingRight={2}
        // paddingLeft={"62px"}
        justifyContent="flex-end"
        // mWidth={'1000px'}
        // marginRight={workspaceOpened ? "5%" : "10%"}
        // marginRight={"10%"}
        marginLeft={"20%"}
        wordBreak={'break-word'}
        // ml={2}
        pt ={prevMsg?.sender === "ai" ? "32px" : "0px"}
      >
        <Box flexDir={'column'} p={"12px"} backgroundColor={'#E4F0FF'} borderRadius={'8px'} maxWidth={ workspaceOpened ? "100%": "60%"}>
          <Box>
            <Text paddingY="0px" fontSize={"15px"} fontWeight={"medium"} color={"#1D1D1D"} fontFamily="sans-serif" whiteSpace="pre-line">{message.simple_message.text}</Text>
          </Box>
          <Box>
            {message.simple_message.filename ? (
              <Box paddingTop={"12px"}>
                <DisplayFile 
                  filename={message.simple_message.filename}
                  fileId={message.simple_message.file_id}
                  workspaceOpened={workspaceOpened} 
                />
              </Box>
            ) : null}
          </Box>
        </Box>
      </Flex>
    );
  if (message.sender === 'system')
    return (
      <HStack
      gap={2} wordBreak={'break-word'} p={"8px"} pt = { prevMsg?.sender === "human" ? "40px" : "8px" } 
      marginRight={"25%"} 
      >
        {
          <Box style={{ minWidth: '36px' }} pY={0} alignSelf={"flex-start"}>
            <IconButton
              sx={{
                background: 'transparent',
                border: 'none',
                padding: 0,
                margin: 0,
              }}
            >
              <InfoOutlined
                sx={{
                  color: '#AE4863',
                  fontSize: '24px',
                }}
              />
            </IconButton>
          </Box>
        }
        <Box flexDir={'column'} gap={2} paddingTop="0px" alignSelf={"center"}>
          <MessageText message={message} />
        </Box>
      </HStack>
    )
};

export default MessageTile;

const DisplayFile = ({filename, fileId, workspaceOpened}) => {

  return (
    <Link
      onClick={() => DownloadFile2(fileId, filename)}
      fontWeight="regular"
      cursor={'pointer'}
    >
      <HStack gap={1} alignItems={"center"}>
        <FileIcon
          fileExtension={
            filename.split('.').reverse()[0]
          }
          size="xl"
        />
        <Text fontSize="14px" fontFamily={"sans-serif"} isTruncated maxWidth={ workspaceOpened ? "120px" : "100%"}>{filename}</Text>
      </HStack>
    </Link>
  )
}

const MessageText = ({ message }) => {
  const myMessage = message;

  
  if (!myMessage) return null;
  
  const { type, simple_message, simple_html_message } = myMessage;
  // const myHtmlMessage =
  const sanitizedHTML = DOMPurify.sanitize(simple_html_message?.text);

  if (simple_message?.port === 'thinking')
    return <Box 
      bgGradient="linear(to-r, #ffffff 0%, #2a303c 25%)"
      bgClip="text"
      animation="shimmer 2s infinite"
      sx={{
        "@keyframes shimmer": {
          "0%": { backgroundPosition: "200% 0" },
          "100%": { backgroundPosition: "-200% 0" },
        },
        backgroundSize: "200% 100%",
        color: "transparent",
      }}
      fontWeight={500} 
      color={"#1D1D1D"}
      fontFamily="'Inter', sans-serif"
    ><Text fontWeight={500} >{simple_message?.text}</Text></Box>;
  if (type === 'ack') return null;
  if (type === 'error') return <Box>
    <Text color={"#AE4863"}>
      {message?.error.message}
    </Text>
    </Box>;
  if (type === 'simple_message') return (
    <Box>
      <Box><Text fontWeight={"regular"} color={"#1D1D1D"} fontFamily="sans-serif" fontSize={"15px"} whiteSpace="pre-line">{simple_message?.text}</Text></Box>
      {message.simple_message.files.map((file) => (
        <DisplayFile 
          filename={file.name}
          fileId={file.id} 
        />
      ))}
    </Box>
  );
  if (type === 'simple_html_message')
    return (
      <Flex flexDir={'column'} gap={2}>
          <Box paddingLeft={"4px"}
            fontWeight={"regular"} color={"#1D1D1D"} fontFamily="sans-serif" fontSize={"15px"}
            dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
            style={{ overflowX: 'auto' }}
          />
          {simple_html_message.files.map((file) => (
            <DisplayFile 
              filename={file.name}
              fileId={file.id} 
            />
          ))}
      </Flex>
    );
};
